

























import Vue from 'vue'
import { InvoiceDetail } from '@/types/api-docs'

export interface DataType {
  invoice: InvoiceDetail
  isFormValid: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rules: any
}

export default Vue.extend({
  props: {
    invoiceProp: {
      type: Object,
      required: true,
    },
    isFormValidProp: {
      type: Boolean,
      required: true,
    },
  },
  data(): DataType {
    return {
      invoice: this.invoiceProp,
      isFormValid: this.isFormValidProp,
      rules: {
        required: (value: string) => (value && !!String(value).length) || 'この項目は必須です',
      },
    }
  },
  watch: {
    invoice: {
      handler(newInvoiceDetail: InvoiceDetail) {
        this.$emit('update:invoiceProp', newInvoiceDetail)
      },
      deep: true,
    },
    isFormValid: {
      handler(valid: boolean) {
        this.$emit('update:isFormValidProp', valid)
      },
    },
  },
})
